import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CatalogViewComponentDef } from '@df/catalog-ui/catalog-view.component.def';
import { ICategoryDataV3 } from '@df/catalog/category/category';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { IProductDataV3 } from '@df/catalog/product/product';
import { CategoryViewComponent } from './category/category-view/category-view.component';
import { Category } from './category/category.decorator';
import { Error404Component } from './error/error-404.component';
import { LocalICmsPage } from './page/local/local-page';
import { PageViewComponent } from './page/view/page-view.component';
import { Product } from './product/product.decorator';
import { ProductViewComponent } from './product/view/product-view.component';
@Component({
    selector: 'catalog-view',
    templateUrl: 'catalog-view.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ ProductViewComponent, Error404Component, PageViewComponent, CategoryViewComponent]
})
export class CatalogViewComponent extends CatalogViewComponentDef {
    get modelAsProduct(): Product<IProductDataV3> {
        return this.model as Product<IProductDataV3>;
    }

    get modelAsCategory(): Category<ICategoryDataV3> {
        return this.model as Category<ICategoryDataV3>;
    }

    get modelAsPage(): LocalICmsPage<IPageDataV3> {
        return this.model as LocalICmsPage<IPageDataV3>;
    }
}
